export type LogLevel = 'silent' | 'error' | 'warn' | 'info' | 'debug';

const LEVELS: Record<LogLevel, number> = {
  silent: 0,
  error: 1,
  warn: 2,
  info: 3,
  debug: 4,
};

// Default: In Produktion leiser (warn), in Dev/Preview informativer (info)
const defaultLevel: LogLevel = (import.meta.env.PROD ? 'warn' : 'info');
const envLevel = (import.meta.env.VITE_LOG_LEVEL || defaultLevel).toLowerCase() as LogLevel;
const currentLevel: LogLevel = envLevel in LEVELS ? envLevel : defaultLevel;

function shouldLog(level: LogLevel): boolean {
  return LEVELS[level] <= LEVELS[currentLevel];
}

function ts(): string {
  try {
    return new Date().toISOString().split('T')[1]?.replace('Z', '') || '';
  } catch {
    return '';
  }
}

export const logger = {
  debug: (...args: any[]) => {
    if (!shouldLog('debug')) return;
     
    console.log('%c[DEBUG]%c ' + ts(), 'color:#6b7280;font-weight:700', 'color:#9ca3af', ...args);
  },
  info: (...args: any[]) => {
    if (!shouldLog('info')) return;
     
    console.log('%c[INFO ]%c ' + ts(), 'color:#2563eb;font-weight:700', 'color:#9ca3af', ...args);
  },
  warn: (...args: any[]) => {
    if (!shouldLog('warn')) return;
     
    console.warn('%c[WARN ]%c ' + ts(), 'color:#f59e0b;font-weight:700', 'color:#9ca3af', ...args);
  },
  error: (...args: any[]) => {
    if (!shouldLog('error')) return;
     
    console.error('%c[ERROR]%c ' + ts(), 'color:#ef4444;font-weight:700', 'color:#9ca3af', ...args);
  },
};

export default logger;
